import type { Auftrag } from '@awf/shared';
import { Link } from 'react-router';
import { HINWEIS_VERWORFEN_TEXT } from './entscheidung-spalte.js';
import { PDP_BLOECKE } from './pdp-bloecke.js';
import stile from './run-detail-page.module.css';

/**
 * Kurzkarte des PDP-Befunds auf der Detailseite (Spec 2026-10-07, Abschnitt 4.3). Entschieden
 * wird auf der Entscheidungsseite; hier stehen nur Grund und Zahlen. Den Weg dorthin traegt der
 * eine Knopf "Jetzt pruefen" der Beitragskarte, wie in der Content-Factory. Ohne
 * `auditId` (kein Bedarf) gibt es nichts zu zeigen -- dafuer hat die Detailseite ihren Hinweis.
 */
export function BefundKarte({ auftrag }: { auftrag: Auftrag }) {
  const befund = auftrag.befund;
  if (auftrag.typ !== 'pdp' || !befund?.auditId) return null;
  const ziel = `/auftraege/${encodeURIComponent(auftrag.runId)}/entscheidung`;

  if (auftrag.status !== 'wartet_auf_entscheidung') {
    return (
      <div className={stile.befund}>
        {auftrag.pdpEntscheidung?.hinweisVerworfen && auftrag.pdpEntscheidung.zusatzhinweis && (
          <div className="eds-alert eds-alert--warning" role="status">
            <p>{HINWEIS_VERWORFEN_TEXT}</p>
          </div>
        )}
        <div className={stile.kartenfuss}>
          <Link className="eds-button eds-button--secondary" to={ziel}>
            Befund ansehen
          </Link>
        </div>
      </div>
    );
  }

  const bloecke = befund.bloecke;
  return (
    <div className={stile.befund}>
      <dl className={stile.kennwerte}>
        <div>
          <dt>Seite</dt>
          <dd>{befund.h1 || '—'}</dd>
        </div>
        <div>
          <dt>Adresse</dt>
          <dd>
            <a href={befund.url} target="_blank" rel="noreferrer">
              {befund.url}
            </a>
          </dd>
        </div>
        <div>
          <dt>Grund</dt>
          <dd>{befund.grund || '—'}</dd>
        </div>
        {befund.empfehlungen !== undefined && (
          <div>
            <dt>Empfehlungen</dt>
            <dd>{befund.empfehlungen}</dd>
          </div>
        )}
      </dl>
      {bloecke && (
        <ul className={stile.chips} aria-label="Empfehlungen je Block">
          {PDP_BLOECKE.map((b) => (
            <li key={b.schluessel} className="eds-chip">
              {b.kurz} {bloecke[b.schluessel]}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
